import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function ThemeConfig({ children }) {
  const themeOptions = {
    palette: {
      primary: {
        main: "#023a7a",
      },
      secondary: {
        main: "#023a7a",
      },
      text: {
        primary: "#212529",
      },
    },
    typography: {
      fontFamily: '"Parkinsans", sans-serif',
    },
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: "#023a7a", // unchecked color
            "&.Mui-checked": {
              color: "#023a7a", // checked color
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: "#023a7a", // unchecked color
            "&.Mui-checked": {
              color: "#023a7a", // checked color
            },
          },
        },
      },
    },
  };

  const theme = createTheme(themeOptions);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
